module.exports = __webpack_public_path__ + "assets/46f9d241ccce3f1acdb12a17b3022ac3.png";